import tw from 'twin.macro'
import { useContext } from 'react'
import { MCPaymentsTableContext } from '../payments-table/MCPaymentsTable.context'
import { TableSearch } from 'src/components/shared/table/TableSearch'
import { MCPaymentStatusSelect } from './MCPaymentStatusSelect'
import { MCPaymentsBatchActionButton } from './action/MCPaymentsBatchActionButton'
import { UserPermission } from 'src/constants/user'
import useCheckPermissions from 'src/hooks/useCheckPermissions'

export const MCPaymentsHeader = () => {
  const { setSearchQuery, searchQuery } = useContext(MCPaymentsTableContext)

  const { hasPermission } = useCheckPermissions()

  return (
    <div
      css={tw`flex flex-row items-center justify-between px-4 py-3 bg-white rounded-t-lg border-0 border-b border-solid border-[#EDEDED]`}
    >
      <div css={tw`flex flex-row items-center gap-4`}>
        <TableSearch searchQuery={searchQuery} onChangeSearchQuery={setSearchQuery} />
        <MCPaymentStatusSelect />
      </div>
      {hasPermission(UserPermission.PaymentsDelete) && <MCPaymentsBatchActionButton />}
    </div>
  )
}
